jQuery(document).ready(function(){

  if(jQuery(".slideshow").length){
    var slider = tns({
      container: '.slideshow',
      items: 1,
      slideBy: 'page',
      autoplay: true,
      autoplayTimeout: 7500,
      touch: true,
      mouseDrag: true,
      speed: 500,
      nav: false,
      loop: true,
      rewind: false,
      autoplayButton: false,
      autoplayButtonOutput: false,
      preventActionWhenRunning: true,
      controlsContainer: ".slideshow-wrapper .controls"
    });
  }

});



// WEBPACK FOOTER //
// ./assets/js/slideshow.js